<template>
  <base-section id="galleries">
    <base-section-heading
      color="primary"
      title="Backhoe Loader"
    />
    <v-container>
      <v-carousel
        height="auto"
        hide-delimiters
      >
        <v-carousel-item
          v-for="(item,i) in itemsbhl"
          :key="i"
          :src="item.src"
        />
      </v-carousel>
    </v-container>
    <base-section-heading
      color="primary"
      title="Skid Steer Loader"
    />
    <v-container>
      <v-carousel
        height="auto"
        hide-delimiters
      >
        <v-carousel-item
          v-for="(item,i) in itemsssl"
          :key="i"
          :src="item.src"
        />
      </v-carousel>
    </v-container>
    <base-section-heading
      color="primary"
      title="Telescopic Handler"
    />
    <v-container>
      <v-carousel
        height="auto"
        hide-delimiters
      >
        <v-carousel-item
          v-for="(item,i) in itemsth"
          :key="i"
          :src="item.src"
        />
      </v-carousel>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    data: () => ({
      itemsbhl: [
        {
          src: require('@/assets/bhl1.webp'),
        },
        {
          src: require('@/assets/bhl2.webp'),
        },
        {
          src: require('@/assets/bhl3.webp'),
        },
        {
          src: require('@/assets/bhl4.webp'),
        },
        {
          src: require('@/assets/bhl5.webp'),
        },
        {
          src: require('@/assets/bhl6.webp'),
        },
        {
          src: require('@/assets/bhl7.webp'),
        },
        {
          src: require('@/assets/bhl8.webp'),
        },
      ],
      itemsssl: [
        {
          src: require('@/assets/ssl1.webp'),
        },
        {
          src: require('@/assets/ssl2.webp'),
        },
        {
          src: require('@/assets/ssl3.webp'),
        },
        {
          src: require('@/assets/ssl4.webp'),
        },
        {
          src: require('@/assets/ssl5.webp'),
        },
        {
          src: require('@/assets/ssl6.webp'),
        },
      ],
      itemsth: [
        {
          src: require('@/assets/tl1.webp'),
        },
        {
          src: require('@/assets/tl2.webp'),
        },
        {
          src: require('@/assets/tl3.webp'),
        },
        {
          src: require('@/assets/tl4.webp'),
        },
        {
          src: require('@/assets/tl5.webp'),
        },
        {
          src: require('@/assets/tl6.webp'),
        },
        {
          src: require('@/assets/tl7.webp'),
        },
        {
          src: require('@/assets/tl8.webp'),
        },
      ],
    }),
  }
</script>
